__turbopack_context__.v({
  "className": "sora_38c0a1de-module__JYICCa__className",
  "variable": "sora_38c0a1de-module__JYICCa__variable",
});
